export const items = [
  { id: "name", label: "Name" },
  { id: "location", label: "Location" },
  { id: "startDate", label: "Start Date" },
  { id: "endDate", label: "End Date" },
  { id: "historicalTreeCost", label: "Hist. Tree Cost" },
  { id: "historicalMaterialCost", label: "Hist. Mat. Cost" },
  { id: "historicalFactor", label: "Hist. Factor" },
  { id: "createdBy", label: "Created By" },
];

export const getKeys = (onEdit, onDelete) => [
  { value: "name" },
  { value: "location.name" },
  { value: "startDate", isDate: true },
  { value: "endDate", isDate: true },
  { value: "historicalTreeCost", isCurrency: true },
  { value: "historicalMaterialCost", isCurrency: true },
  { value: "historicalFactor", isCurrency: true },
  { value: "createdBy.name", defaultValue: "—" },
];
